import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { FeatureFlagService } from './feature-flag.service';
import { FeatureNames } from 'feature-flag-config/generated/feature-names';

@Directive({
  selector: '[appIfFeatureOff]'
})
export class IfFeatureOffDirective implements OnInit {
  @Input('appIfFeatureOff') featureName: FeatureNames;

  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private featureFlagService: FeatureFlagService
  ) {
  }

  ngOnInit() {
    const featureOff = this.featureFlagService.featureOff(this.featureName);
    if (featureOff && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!featureOff && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
